import { createReducer } from '@reduxjs/toolkit';
import { OrganizationBankAccountState } from './organization-bank-account.types';

const initialState: OrganizationBankAccountState = {
  organizationBankAccounts: [],
};

export default createReducer(initialState, (builder) => {});
